import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { LoginForm } from '@/components/auth/LoginForm';
import { useCurrentAssistant } from '@/hooks/useAssistantAuth';

const ASSISTANT_RESTAURANT_KEY = 'digimataam_assistant_restaurant';

export const Route = createFileRoute('/assistant-login')({
  component: AssistantLogin,
  validateSearch: (search: Record<string, unknown>) => ({
    restaurant: search['restaurant'] as string | undefined,
  }),
});

function AssistantLogin() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const { data: assistant } = useCurrentAssistant();

  // Get restaurant ID from query params or localStorage
  const restaurantFromUrl = search['restaurant'];
  const restaurantFromStorage = typeof window !== 'undefined'
    ? localStorage.getItem(ASSISTANT_RESTAURANT_KEY)
    : null;
  const restaurant = restaurantFromUrl || restaurantFromStorage || '';

  // Persist restaurant ID when visiting with URL param
  useEffect(() => {
    if (restaurantFromUrl) {
      localStorage.setItem(ASSISTANT_RESTAURANT_KEY, restaurantFromUrl);
    }
  }, [restaurantFromUrl]);

  // Redirect if already authenticated
  useEffect(() => {
    if (assistant) {
      navigate({ to: '/assistant-dashboard' });
    }
  }, [assistant, navigate]);

  if (!restaurant) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <div className="text-center max-w-md">
          <h1 className="text-2xl font-bold mb-2">Invalid Login Link</h1>
          <p className="text-muted-foreground">
            Please use the login link provided by your administrator.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-900">
      <LoginForm
        mode="assistant"
        restaurantId={restaurant}
        onSuccess={() => navigate({ to: '/assistant-dashboard' })}
      />
    </div>
  );
}
